import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskFieldsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-fields',
	path: '/jira/servicedesk/projects/:projectKey/settings/fields',
	exact: true,
};
